import { Link } from '@tanstack/react-router'
import { forwardRef, type ReactNode, type Ref } from 'react'

type UiKitLinkProps = {
  to?: string
  href?: string
  children?: ReactNode
  [key: string]: unknown
}

const UiKitLink = forwardRef(function UiKitLink(
  { to, href, children, ...props }: UiKitLinkProps,
  ref: Ref<HTMLAnchorElement>,
) {
  const destination = to ?? href ?? '/'

  if (
    typeof destination === 'string' &&
    (destination.startsWith('http') || destination.startsWith('mailto:'))
  ) {
    return (
      <a href={destination} ref={ref} {...props}>
        {children}
      </a>
    )
  }

  return (
    <Link to={destination} ref={ref} {...props}>
      {children}
    </Link>
  )
})

export default UiKitLink
